import {gql} from "@irati/utils/gql"

export default gql`
  fragment fullProductPermissions on ProductPermissions {
    uuid
    businessId
    ghost {
      isGhost
      ghostId
    }
    admin {
      people
      teams
      tenant
      selfSignUp
      dealVisibility
      sso
      customPermissions
      reporting
      billingUnit
      reportingBeta
      directorySync
      singleSignOn
      oldSelfServeRegistration
      domainBasedSelfRegistration
      benefitMarketplace
      aiReporting
    }
    medical {
      medical
      reports
      onlineGP
    }
    platform {
      cultureHub {
        update
      }
      homepageTiles {
        read
        update
      }
      companyValues
      payments {
        zip
      }
      contentCards
      homepageLanesHidden
      customRewards
      cultureHubFileUploadHidden
      hideCashback
      hasCultureHub
      userSavings
    }
    perks {
      redemptions
      favourites
    }
    recognition {
      attachReward
      createPoll
      share
      viewReward
      viewRewardDetails
      poll {
        create
        delete
      }
      rewards {
        create
        viewOff
        viewLimited
      }
      recognition {
        everyone
        create
        update
        sendToEveryone
        sendToTeams
      }
      votes {
        update
      }
      comments {
        update
        delete
      }
    }
    wallet {
      pointsBlendEligible
      users
      treatTokens
      rewardWallet
      tenantWallet
      canPurchasePoints
      canRequestPoints
      canApprovePointsRequest
      flexiRewards {
        view
        canRewardEmployees
        canTopUpRewardPoints
        canViewFullReports
        canAdvancedBudgeting
        hasAutoApprovals
        budget {
          manageFunds {
            betweenAny
            fromUnassigned
          }
          manageCategory
        }
        merchandiseHidden
      }
    }
    wellnessHub {
      enabled
      visible
      wellbeing
      eap
      eapTier
      onlineGP
      eapContactNumber
      wellnessAssessment
      wellbeingSSO
    }
    benefits {
      ctw
      he
      alp
      pg
      sf
      cs
      hcp
      gm
      pa
      tal
      ibs
      nbs
      eap
      bl
      el
      hasOrderManagementAccess
    }
    localBenefits {
      enabled
      hasLocalBenefits
    }
  }
`
